import _ from 'lodash'

export const LOCALE_PREFIX = 'components.Dialog.components.ManageGroups'

export const MANAGE_GROUPS_DIALOG_INIT = 'MANAGE_GROUPS_DIALOG_INIT'
export const MANAGE_GROUPS_DIALOG_SET_ROWS = 'MANAGE_GROUPS_DIALOG_SET_ROWS'
export const MANAGE_GROUPS_DIALOG_LOADING_TRUE = 'MANAGE_GROUPS_DIALOG_LOADING_TRUE'
export const MANAGE_GROUPS_DIALOG_LOADING_FALSE = 'MANAGE_GROUPS_DIALOG_LOADING_FALSE'
export const MANAGE_GROUPS_DIALOG_IMPORT = 'MANAGE_GROUPS_DIALOG_IMPORT'
export const IMPORT_GROUP_MEMBERS_REQUEST = (country, index) =>
    `IMPORT_GROUP_MEMBERS_${index}_${_.toUpper(country)}_REQUEST`
export const MANAGE_GROUPS_DIALOG_SET_ROW_LOADING = 'MANAGE_GROUPS_DIALOG_SET_ROW_LOADING'
export const MANAGE_GROUPS_DIALOG_CREATE_NEW_GROUP = 'MANAGE_GROUPS_DIALOG_CREATE_NEW_GROUP'
export const MANAGE_GROUPS_DIALOG_IMPORT_SINGLE = 'MANAGE_GROUPS_DIALOG_IMPORT_SINGLE'
export const MANAGE_GROUPS_DIALOG_IMPORT_REMOVE = 'MANAGE_GROUPS_DIALOG_IMPORT_REMOVE'
export const MANAGE_GROUPS_GET_GROUPS_FOR_ENTITY_REQUEST = 'MANAGE_GROUPS_GET_GROUPS_FOR_ENTITY_REQUEST'
